var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.colorDto.value
        ? _c("div", { staticClass: "color-div-base selected-div" }, [
            _c(
              "div",
              {
                staticStyle: {
                  float: "left",
                  display: "flex",
                  "align-items": "center",
                },
              },
              _vm._l(_vm.colorDto.colors, function (c, index) {
                return _c("span", {
                  key: index,
                  staticClass: "color-span-base",
                  style: { background: _vm.formatBgColor(c, true) },
                })
              }),
              0
            ),
            _c("span", { staticStyle: { "margin-left": "4px" } }),
            _c(
              "span",
              { staticClass: "reset-span", on: { click: _vm.reset } },
              [
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: {
                      effect: "dark",
                      content: _vm.$t("commons.reset"),
                      placement: "top",
                    },
                  },
                  [_c("i", { staticClass: "el-icon-refresh" })]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "el-popover",
        {
          attrs: {
            placement: "bottom",
            "popper-class": "gradient-popper",
            width: _vm.popWidth,
            "append-to-body": true,
            trigger: "click",
          },
          on: { show: _vm.whenShow },
        },
        [
          _c(
            "div",
            { staticClass: "custom-switch-div" },
            [
              _c("el-switch", {
                attrs: {
                  "active-text": _vm.$t("commons.custom"),
                  "inactive-text": "",
                },
                model: {
                  value: _vm.enableCustom,
                  callback: function ($$v) {
                    _vm.enableCustom = $$v
                  },
                  expression: "enableCustom",
                },
              }),
            ],
            1
          ),
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            _vm._l(
              _vm.tabPanes.filter(function (item) {
                return (
                  item.name === "simple" ||
                  (_vm.showIndex === 1 && item.name === "split_gradient") ||
                  (_vm.showIndex === 2 && item.name === "gradient")
                )
              }),
              function (pane, i) {
                return _c(
                  "el-tab-pane",
                  { key: i, attrs: { label: pane.label, name: pane.name } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "color-tab-content",
                        attrs: { id: "color-tab-content-" + i },
                        on: { click: _vm.handler },
                      },
                      _vm._l(pane.data, function (option) {
                        return _c(
                          "div",
                          {
                            key: option.value,
                            staticClass:
                              "el-select-dropdown__item color-div-base",
                            class:
                              option.value === _vm.colorDto.value
                                ? "selected hover editor"
                                : "",
                            on: {
                              click: function ($event) {
                                return _vm.selectNode(option)
                              },
                            },
                          },
                          [
                            option.value !== _vm.colorDto.value ||
                            !_vm.enableCustom
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      float: "left",
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  _vm._l(option.colors, function (c, index) {
                                    return _c("span", {
                                      key: index,
                                      staticClass: "color-span-base",
                                      style: {
                                        background: _vm.formatBgColor(c),
                                      },
                                    })
                                  }),
                                  0
                                )
                              : _vm._e(),
                            option.value !== _vm.colorDto.value ||
                            !_vm.enableCustom
                              ? _c(
                                  "span",
                                  { staticStyle: { "margin-left": "4px" } },
                                  [_vm._v(_vm._s(option.name))]
                                )
                              : _vm._l(option.colors, function (co, index) {
                                  return _c(
                                    "span",
                                    {
                                      key: index,
                                      staticClass: "color-span-base",
                                      class:
                                        option.value.endsWith(
                                          "_split_gradient"
                                        ) && index % 8 !== 0
                                          ? "static-editor"
                                          : "is-editor",
                                    },
                                    [
                                      option.value.endsWith(
                                        "_split_gradient"
                                      ) && index % 8 !== 0
                                        ? _c("span", {
                                            staticClass:
                                              "color-span-base-split",
                                            style: {
                                              background: _vm.formatBgColor(co),
                                            },
                                          })
                                        : option.value.endsWith(
                                            "_continuous_gradient"
                                          )
                                        ? _c("de-color-picker", {
                                            ref: "de-color-picker",
                                            refInFor: true,
                                            attrs: {
                                              id: option.value + index,
                                              "base-id": option.value + index,
                                              "show-alpha": "",
                                              "color-format": "rgb",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.switchColorItem(
                                                  option.colors,
                                                  option.value
                                                )
                                              },
                                            },
                                            model: {
                                              value: option.colors[index],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  option.colors,
                                                  index,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "option.colors[index]",
                                            },
                                          })
                                        : _c("el-color-picker", {
                                            attrs: {
                                              "popper-class":
                                                "gradient-picker-dropdown",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.switchColorItem(
                                                  option.colors,
                                                  option.value
                                                )
                                              },
                                            },
                                            model: {
                                              value: option.colors[index],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  option.colors,
                                                  index,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "option.colors[index]",
                                            },
                                          }),
                                    ],
                                    1
                                  )
                                }),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ]
                )
              }
            ),
            1
          ),
          _c(
            "el-select",
            {
              ref: "colorSelect",
              staticClass: "form-gender-select",
              attrs: {
                slot: "reference",
                "popper-class": "gradient-tree-select",
                placeholder: _vm.$t("commons.please_select"),
              },
              on: { focus: _vm._popoverShowFun },
              slot: "reference",
              model: {
                value: _vm.colorDto.value,
                callback: function ($$v) {
                  _vm.$set(_vm.colorDto, "value", $$v)
                },
                expression: "colorDto.value",
              },
            },
            _vm._l(_vm.selectOptions, function (item) {
              return _c("el-option", {
                key: item.label,
                attrs: { label: item.label, value: item.id },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }